/** v4 item 8: an error while drawing the page shows a short message with "Tải lại trang" instead of a blank page, and
 * goes to the server once (errorReport.ts, with React's component stack). */
import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  onError: (error: unknown, componentStack: string) => void;
}

export class ErrorBoundary extends Component<Props, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: unknown, info: ErrorInfo) {
    this.props.onError(error, info.componentStack ? `Component stack:${info.componentStack}` : "");
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="crash-page">
        <section className="card" role="alert">
          <h1>Trang gặp lỗi ngoài ý muốn</h1>
          <p>Lỗi đã được ghi lại để DTAA khắc phục. Ảnh đã gửi đi vẫn được xử lý; tải lại trang để tiếp tục.</p>
          <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>Tải lại trang</button>
        </section>
      </main>
    );
  }
}
